import request from '@/router/axios'

export const getList = (current, size, params, deptId) => request({
  url: '/api/mcc-worker/employment/passportList',
  method: 'get',
  params: {
    ...params,
    current,
    size,
    deptId,
  },
})

export const updatePassport = params => request({
  url: '/api/mcc-worker/info/update',
  method: 'post',
  data: params,
})

export const downLoadExcel = params => request({
  url: '/api/mcc-worker/employment/passportExcel',
  method: 'get',
  responseType: 'blob',
  params: {
    size: -1,
    ...params,
  },
})

export const upLoadExcel = (filename, file) => {
  const formData = new FormData()
  formData.append(filename, file)
  return request({
    url: '/api/mcc-worker/employment/passportExcel2',
    method: 'post',
    data: formData,
  })
}

// 获取所有护照信息接口
export const getPassportList = (current, size, params, deptId) => request({
  url: '/api/mcc-worker/employment/passportAll',
  method: 'get',
  params: {
    ...params,
    current,
    size,
    deptId,
  },
})

// 归还护照
export const returnPassport = params => request({
  url: '/api/mcc-worker/info/update',
  method: 'post',
  data: params,
})

// 获取护照借出信息接口
export const getPassportLendList = (current, size, params) => request({
  url: '/api/mcc-worker/processpassportbor/page1',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})

// 护照借出流程下载接口
export const downLoadProcess = params => request({
  url: '/api/mcc-worker/processfield/DaoChuPassportPerson',
  method: 'get',
  responseType: 'blob',
  params: {
    formId: '28',
    ...params,
  },
})

// 护照借出流程全部导出接口
export const downLoadAllProcess = params => request({
  url: '/api/mcc-worker/processfield/DaoChuPassport',
  method: 'get',
  responseType: 'blob',
  params: {
    formId: '28',
    ...params,
  },
})

export default {
  getList,
  updatePassport,
}
